import type { SeoRequiredPageId } from '../page-registry';
import type { PageSeoContent } from '../schema';

export const seoContent = {
  home: {
    title: 'Exquisite Wedding Gifting & Collections',
    description:
      'Discover our curated collection of traditional Indian wedding gifts, combining timeless heritage with modern sophistication. Premium silk sarees, wedding collections, and personalized gifting solutions.',
    keywords:
      'silk sarees, wedding gifts, traditional sarees, wedding collections, Indian silk, bridal sarees, Tamil Nadu silk',
    canonicalPath: '/',
  },
  about: {
    title: 'About Us - A Legacy of Silk Craftsmanship',
    description:
      "Learn about Sree Silks' journey in crafting exquisite silk sarees and our commitment to preserving traditional artistry. Five generations of excellence in silk weaving.",
    keywords:
      'about Sree Silks, silk craftsmanship, traditional weaving, Tamil Nadu heritage, silk saree history, artisan crafts',
    canonicalPath: '/about',
    type: 'article',
  },
  collections: {
    title: 'Collections',
    description:
      'Explore live Sree Silks collections with a more browseable public catalog, collection landing pages, and assisted-commerce enquiry shortcuts.',
    canonicalPath: '/collections',
  },
  contact: {
    title: 'Contact Us',
    description:
      'Get in touch with Sree Silks for inquiries about our collections, wedding gifting, or custom orders. Our team is ready to assist you with personalized solutions.',
    keywords: 'contact Sree Silks, silk saree inquiries, wedding gifting consultation, custom orders, customer support',
    canonicalPath: '/contact',
  },
  journey: {
    title: 'Our Journey Through Generations',
    description:
      'Explore the rich history and evolution of Sree Silks through generations of excellence in silk craftsmanship. From traditional beginnings to modern innovation.',
    keywords:
      'Sree Silks history, silk craftsmanship, traditional weaving, Tamil Nadu heritage, family business, silk legacy',
    canonicalPath: '/journey',
    type: 'article',
  },
  'wedding-gifting': {
    title: 'Wedding Gifting: Weaving Love & Tradition',
    description:
      "Immerse yourself in the art of heartfelt gifting. Discover exquisite sarees, dhotis, and bespoke gifting experiences from Sree Silks, honoring Tamil Nadu's rich traditions with modern elegance.",
    keywords:
      'wedding gifts, silk sarees, traditional gifts, wedding collections, Tamil Nadu traditions, wedding gifting, customized gifts',
    canonicalPath: '/wedding-gifting',
    type: 'product',
  },
} satisfies Record<SeoRequiredPageId, PageSeoContent>;
